interface ShareButtonsProps {
  title: string;
}

export default function ShareButtons({ title }: ShareButtonsProps) {
  const shareUrl = window.location.href;

  const handleShare = (platform: string) => {
    let url = '';
    switch (platform) {
      case 'facebook':
        url = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`;
        break;
      case 'twitter':
        url = `https://twitter.com/intent/tweet?url=${encodeURIComponent(shareUrl)}&text=${encodeURIComponent(title)}`;
        break;
      case 'linkedin':
        url = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(shareUrl)}`;
        break;
      case 'whatsapp':
        url = `https://wa.me/?text=${encodeURIComponent(title + ' ' + shareUrl)}`;
        break;
    }
    if (url) {
      window.open(url, '_blank', 'width=600,height=400');
    }
  };

  return (
    <div className="flex items-center gap-4 mb-12 pb-8 border-b border-gray-200">
      <span className="text-sm font-semibold text-gray-700">Share this article:</span>
      <div className="flex items-center gap-2">
        <button
          onClick={() => handleShare('facebook')}
          className="w-10 h-10 flex items-center justify-center rounded-full bg-[#1877F2] text-white hover:opacity-90 transition-opacity cursor-pointer"
          aria-label="Share on Facebook"
        >
          <i className="ri-facebook-fill text-lg"></i>
        </button>
        <button
          onClick={() => handleShare('twitter')}
          className="w-10 h-10 flex items-center justify-center rounded-full bg-[#1DA1F2] text-white hover:opacity-90 transition-opacity cursor-pointer"
          aria-label="Share on Twitter"
        >
          <i className="ri-twitter-fill text-lg"></i>
        </button>
        <button
          onClick={() => handleShare('linkedin')}
          className="w-10 h-10 flex items-center justify-center rounded-full bg-[#0A66C2] text-white hover:opacity-90 transition-opacity cursor-pointer"
          aria-label="Share on LinkedIn"
        >
          <i className="ri-linkedin-fill text-lg"></i>
        </button>
        <button
          onClick={() => handleShare('whatsapp')}
          className="w-10 h-10 flex items-center justify-center rounded-full bg-[#25D366] text-white hover:opacity-90 transition-opacity cursor-pointer"
          aria-label="Share on WhatsApp"
        >
          <i className="ri-whatsapp-fill text-lg"></i>
        </button>
      </div>
    </div>
  );
}
